import type {PinTransaction} from '../../types';

import {dateToReadableDate} from '@date-picker';
import {numberFormat} from 'utils/Helper';

import PinInfoRow from '../../../components/common/PinInfoRow/PinInfoRow';

type TransactionDetailsProps = {
  data?: PinTransaction;
};

const TransactionDetails: React.FC<TransactionDetailsProps> = ({data}) => {
  return (
    <div className="flex flex-col overflow-y-auto text-body-sm">
      <PinInfoRow title="شماره تراکنش" value={data?.code} />
      <PinInfoRow title="مبلغ فاکتور" value={`${numberFormat(data?.price ?? 0)} تومان`} />
      <PinInfoRow title="درصد مالیات" value={`${data?.tax_rate ?? 0}%`} />
      <PinInfoRow
        title="مبلغ جمع کل"
        value={`${numberFormat(data?.total_price ?? 0)} تومان`}
        hasBorder={false}
      />
      <section className="flex max-h-125 flex-col overflow-y-auto">
        <h3 className="px-2.5 py-4 text-subtitle-lg text-neutral-fg">بسته‌های خریداری شده</h3>
        <div className="flex flex-col">
          {data?.items?.map((item, index) => {
            const hasDiscount = Boolean(item.discount && item.discounted_price);

            return (
              <div
                className="flex items-center justify-between gap-3 border-b border-gray-03 p-2.5 last:border-b-0"
                key={item.id ?? `${item.active_date}-${item.region_name}-${index}`}
              >
                <div className="flex min-w-0 flex-col gap-1">
                  <span className="text-body-sm-emphasis text-neutral-fg">
                    {dateToReadableDate({
                      date: item.active_date ?? '',
                      month: true,
                      day: true
                    })}
                  </span>
                  <span className="text-body-sm text-gray-07">{item.region_name}</span>
                </div>
                <div className="flex shrink-0 items-center gap-1.5 text-body-sm-emphasis">
                  {item.discount ? (
                    <span className="rounded-md bg-destructive px-1.5 text-destructive-on">
                      {item.discount}
                    </span>
                  ) : null}
                  {item.price ? (
                    <span className={hasDiscount ? 'text-gray-07 line-through' : 'text-neutral-fg'}>
                      {numberFormat(item.price)}
                      {!hasDiscount ? ' تومان' : ''}
                    </span>
                  ) : null}
                  {hasDiscount ? (
                    <span className="text-neutral-fg">
                      {numberFormat(item.discounted_price ?? 0)} میلیون
                    </span>
                  ) : null}
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
};

export default TransactionDetails;
